export default {
    ldap: {
        error: '',
        cn: '', 
        telephoneNumber: '', 
        mail: '', 
        sn: '', 
        dn: ''
    }
}